import { defineStore } from 'pinia';
import { useModalStore } from './ModalStore';
import gsap from 'gsap';
import ApiService from '@/services/ApiService';
import { useTerritoryStore } from './TerritoryStore';

export const useDealerStore = defineStore('dealer', {
  state () {
    return {
      dealers: null,
      dealerTerritories: null,
      isSuccessful: false,
      isMode: 'default',
      submitDealerName: null,
      inputType: null,
      mode: 'add',
      selectedDealer: null,
      currentDealer: null,
      incomplete: [],
      isWarning: false,
      dealerInputs: [
        {
          field: 'dealerNumber',
          label: 'Dealer Number',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'territory',
          label: 'Territory*',
          placeholder: 'Territory',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'name',
          label: 'Dealer Name*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'address',
          label: 'Address*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'city',
          label: 'City*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'state',
          label: 'State*',
          placeholder: 'State',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'zip',
          label: 'Zip*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'country',
          label: 'Country*',
          placeholder: 'Country',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'lat',
          label: 'Latitude*',
          value: '',
          placeholder: '',
          type: 'number',
          required: true,
        },
        {
          field: 'lon',
          label: 'Longitude*',
          value: '',
          placeholder: '',
          type: 'number',
          required: true,
        },
        {
          field: 'phone',
          label: 'Phone*',
          value: '',
          placeholder: '',
          type: 'tel',
          required: true,
        },
        {
          field: 'email',
          label: 'Email',
          value: '',
          placeholder: '',
          type: 'email',
          required: false,
        },
        {
          field: 'url',
          label: 'URL',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'dealerLevel',
          label: 'Dealer Level*',
          placeholder: 'Dealer Level',
          value: '',
          type: 'select',
          required: true,
        },
      ],
      dealerAddInputs: [
        {
          field: 'dealerNumber',
          label: 'Dealer Number',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'territory',
          label: 'Territory*',
          placeholder: 'Territory',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'name',
          label: 'Dealer Name*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'address',
          label: 'Address*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'city',
          label: 'City*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'state',
          label: 'State*',
          placeholder: 'State',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'zip',
          label: 'Zip*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'country',
          label: 'Country*',
          placeholder: 'Country',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'lat',
          label: 'Latitude*',
          value: '',
          placeholder: '',
          type: 'number',
          required: true,
        },
        {
          field: 'lon',
          label: 'Longitude*',
          value: '',
          placeholder: '',
          type: 'number',
          required: true,
        },
        {
          field: 'phone',
          label: 'Phone*',
          value: '',
          placeholder: '',
          type: 'tel',
          required: true,
        },
        {
          field: 'email',
          label: 'Email',
          value: '',
          placeholder: '',
          type: 'email',
          required: false,
        },
        {
          field: 'url',
          label: 'URL',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'dealerLevel',
          label: 'Dealer Level*',
          placeholder: 'Dealer Level',
          value: {
            id: 1,
            name: 'None',
          },
          type: 'select',
          required: true,
        },
      ],
      dealerBlankAddInputs: [
        {
          field: 'dealerNumber',
          label: 'Dealer Number',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'territory',
          label: 'Territory*',
          placeholder: 'Territory',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'name',
          label: 'Dealer Name*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'address',
          label: 'Address*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'city',
          label: 'City*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'state',
          label: 'State*',
          placeholder: 'State',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'zip',
          label: 'Zip*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'country',
          label: 'Country*',
          placeholder: 'Country',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'lat',
          label: 'Latitude*',
          value: '',
          placeholder: '',
          type: 'number',
          required: true,
        },
        {
          field: 'lon',
          label: 'Longitude*',
          value: '',
          placeholder: '',
          type: 'number',
          required: true,
        },
        {
          field: 'phone',
          label: 'Phone*',
          value: '',
          placeholder: '',
          type: 'tel',
          required: true,
        },
        {
          field: 'email',
          label: 'Email',
          value: '',
          placeholder: '',
          type: 'email',
          required: false,
        },
        {
          field: 'url',
          label: 'URL',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'dealerLevel',
          label: 'Dealer Level*',
          placeholder: 'Dealer Level',
          value: {
            id: 1,
            name: 'None',
          },
          type: 'select',
          required: true,
        },
      ],
      dealerTableHeaders: [
        { id: '1', value: 'active', title: 'ACTIVE' },
        { id: '2', value: 'dealerName', title: 'DEALER NAME' },
        { id: '3', value: 'location', title: 'LOCATION' },
        { id: '4', value: 'territoryMgr', title: 'TERRITORY MGR' },
        { id: '5', value: 'email', title: 'EMAIL' },
        { id: '6', value: 'phoneNumber', title: 'PHONE NUMBER' },
      ],
      territories: [],
      states: null,
      countries: null,
      dealerLevels: [
        {
          dealerLevelId: 1,
          name: 'None',
        },
        {
          dealerLevelId: 2,
          name: 'Sliver',
        },
        {
          dealerLevelId: 3,
          name: 'Gold',
        },
        {
          dealerLevelId: 4,
          name: 'Platinum',
        },
      ],
    };
  },
  getters: {
    Mode () {
      return this.mode;
    },
    SeletecDealer () {
      return this.selectedDealer;
    },
    CreateDealerInputs () {
      return this.dealerAddInputs;
    },
    EditDealerInputs () {
      return this.dealerInputs;
    }
  },
  actions: {
    setMode (mode) {
      this.mode = mode;
    },
    setSelectedDealer (dealer) {
      this.selectedDealer = dealer;
    },
    async fetchDealers () {
      await ApiService.getDealers().then((response) => {
        this.dealers = response.data;
        console.log(this.dealers);
        // this.dealers = this.dealers.map((item) => {
        //   item.name = this.camelCaseToWords(item.name);
        //   item.address = this.camelCaseToWords(item.address);
        //   item.city = this.camelCaseToWords(item.city);
        //   return item;
        // });
        // console.log(this.dealers);
      });
      await ApiService.getDealerTerritories().then((response) => {
        useTerritoryStore().territories = response.data;
        this.dealerTerritories = response.data;
        useTerritoryStore().territories = useTerritoryStore().territories.sort((a, b) => a.sortorder - b.sortorder);

      });
      await ApiService.getCountries().then((response) => {
        this.countries = response.data;
        const allStates = [];
        this.countries.forEach((item) => {
          const states = item.states;
          allStates.push(...states);
        });
        this.states = allStates;
        useTerritoryStore().tmpStates = this.states;
      });
    },
    async removeDealer (dealerId) {
      gsap.to('#dealer-row-' + dealerId, {
        backgroundColor: '#FFFFFF'
      });
      await ApiService.deleteDealer(dealerId).then(() => {
        ApiService.getDealers().then((response) => {
          this.dealers = response.data;
          // this.dealers = this.dealers.map((item) => {
          //   item.name = this.camelCaseToWords(item.name);
          //   item.address = this.camelCaseToWords(item.address);
          //   item.city = this.camelCaseToWords(item.city);
          //   return item;
          // });
          this.mode = 'add';
          useModalStore().hideModal();
        });
      });
    },
    async submitActiveStatus (item) {
      item.isActive = item.isActive === true ? true : false;
      const payload = item;
      await ApiService.postDealer(payload).then(() => {
        // ApiService.getDealers()
        // .then((response) => {
        //   this.dealers = response.data;
        // });
      });
    },
    toCamelCase (str) {
      return str
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());
    },
    camelCaseToWords (str) {
      const result = str.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    },
    async submitDealer () {
      const inputs = this.mode === 'edit' ? this.dealerInputs : this.dealerAddInputs;
      var payload = {};
      inputs.forEach((item) => {
        if (item.field === 'territory') {
          if (item.value.length === 0) {
            this.incomplete.push('Territory');
          }
          payload.territoryId = item.value.id;
        } else if (item.field === 'country') {
          if (item.value.length === 0) {
            this.incomplete.push('Country');
          }
          payload.country = item.value.isO2;
        } else if (item.field === 'state') {
          if (item.value.length === 0) {
            this.incomplete.push('State');
          }
          payload.state = item.value.abbreviation;
        } else if (item.field === 'dealerLevel') {
          if (item.value.length === 0) {
            this.incomplete.push('Dealer Level');
          }
          payload.dealerLevelId = item.value.dealerLevelId;
        } else {
          if (item.value != null) {
            if (item.value.length === 0 && item.required) {
              this.incomplete.push(item.label);
            }
          } else {
            if (item.required) {
              this.incomplete.push(item.label);
            }
          }
          payload[item.field] = item.value;
        }
      });
      payload.isActive = this.mode === 'edit' ? this.currentDealer.isActive : false;
      payload.dealerId = this.mode === 'edit' ? this.currentDealer.dealerId : 0;
      payload.dealerLevelId = this.mode === 'edit' ? payload.dealerLevelId : 1;
      if (this.incomplete.length > 0) {
        this.isWarning = true;
      } else {
        await ApiService.postDealer(payload).then(() => {
          if (this.mode === 'edit') {
            gsap.to('#dealer-row-' + payload.dealerId, {
              backgroundColor: '#FFFFFF'
            });
            this.dealerInputs = this.dealerInputs.map((item) => {
              if (item.field === 'dealerLevel') {
                item.value = {
                  dealerLevelId: 1,
                  name: 'None',
                };
              } else {
                item.value  = '';
              }
              return item;
            });
          } else {
            this.dealerAddInputs = this.dealerAddInputs.map((item) => {
              if (item.field === 'dealerLevel') {
                item.value = {
                  dealerLevelId: 1,
                  name: 'None',
                };
              } else {
                item.value  = '';
              }
              return item;
            });
          }
          // refresh dealers
          this.isSuccessful = true;
          this.isMode = this.mode;
          this.submitDealerName = payload.name;
          if (this.mode === 'add') {
            this.isMode = 'added';
          } else if (this.mode === 'edit') {
            this.isMode = 'changed';
          }
          this.mode = 'add';
        ApiService.getDealers()
          .then((response) => {
            this.dealers = response.data;
            // this.dealers = this.dealers.map((item) => {
            //   item.name = this.camelCaseToWords(item.name);
            //   item.address = this.camelCaseToWords(item.address);
            //   item.city = this.camelCaseToWords(item.city);
            //   return item;
            // });
          });
        })
        .catch((error) => {
          console.log(error);
        });
      }
      // useModalStore().hideModal()
    },
  },
});
